import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100" style={{ background: "#F8F8FB" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>Comprehensive Android Development Services</h2>
            <p>
              At TekRevol, we excel in creating high-performance, feature-rich
              Android applications using the latest technologies. Our developers
              combine creativity with technical expertise to deliver
              applications that exceed industry standards. Explore our
              specialized services:
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="Hire iOS Developers"
            >
              Hire Top Developers
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>Custom App Development</h4>
                  <p>
                    Our developers specialize in creating dynamic, user-centric
                    apps. Whether you need consumer-facing apps or robust
                    enterprise solutions, we deliver services that turn your
                    concepts into high-performance Android experiences.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>UI/UX Design for Android</h4>
                  <p>
                    Invest in engaging designs and seamless user experiences
                    with our Android developers. Our UI/UX experts craft
                    interfaces that attract users and enhance your app's visual
                    appeal and functionality.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Maintenance & Support for Android Apps</h4>
                  <p>
                    Our services extend beyond launch with comprehensive
                    maintenance and support. Our Android developers ensure your
                    app remains robust, updated, and bug-free for consistent
                    performance long after deployment.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Android App Upgrades & Migrations</h4>
                  <p>
                    Keep your app relevant with seamless upgrades and
                    migrations. Our skilled developers align your app with the
                    latest Android versions and industry standards to enhance
                    performance.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Quality Assurance & Testing</h4>
                  <p>
                    Our developers conduct rigorous testing to meet the highest
                    standards. Count on us for an error-free user experience
                    that distinguishes your Android application from the
                    competition.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
